<info-modal [title]="title" (onOk)="ok()">
	<loading [isLoad]="detailLoader || !details"></loading>

	<table class="table">
		<thead>
			<tr>
				<th></th>
				<th>{{ 'adminstat.common.Domain' | translate }}</th>
				<th>{{ 'adminstat.common.Site' | translate }}</th>
				<th>{{ 'adminstat.support.support.User info' | translate }}</th>
			</tr>
		</thead>
		
		<tbody>
			<tr *ngFor="let stat of details; let i = index">
				<td>
					{{ i + 1 }}
				</td>
				
				<td>
					{{ 'adminstat.billing.domain_billing.registrator' | translate }}: {{ stat.registrator }}
					<br/>
					
					{{ 'adminstat.common.Status' | translate }}
					<span [class]="stat.status == 'registered' ? 'badge badge-success' : 'badge badge-danger'">
						{{ stat.status }}
					</span>
					<br/>
					
					{{ 'adminstat.billing.domain_billing.Date of purchase' | translate }}: {{ stat.time | dateFormat }} <br/>
				</td>
				
				<td class="wrap-ceil">
					<a target="_blank" rel="noreferrer" [href]="'http://' + stat.domainName">{{ stat.domainName }}</a>
				</td>

				<td>
					<site_info [siteUrl]="stat.domainUrl"></site_info>
				</td>
				
				<td>
					<gotosupport [value]="stat.email"></gotosupport>
				</td>
				
				<td>
					{{ 'adminstat.common.Email' | translate }}: {{ stat.email }}
					<br/>
					{{ 'adminstat.common.Username' | translate }}: {{ stat.username }}
				</td>
			</tr>
		</tbody>
	</table>
</info-modal>
